import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import SponsorCard from '../components/SponsorCard';
import { fetchSponsors, useLive } from '../data/live';
import Skeleton from '../components/Skeleton';

export default function SponsorsPage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;

  // No static fallback: an unconfirmed sponsor list must render as empty, never
  // as content.js placeholders (which carry no membership_type and would render
  // corporate members as sponsors). [] = confirmed-empty; null = not-loaded/outage.
  const sponsors = useLive(fetchSponsors, [event?.id]);
  const year = meeting.dates.split(',').pop().trim();

  if (sponsors === undefined) return <Skeleton variant="tile" count={4} />;

  if (!sponsors || !sponsors.length) {
    return (
      <>
        <SectionLabel right="—">Sponsors · {year}</SectionLabel>
        <div className="portal-resource-placeholder">
          Sponsors for this meeting are being confirmed
        </div>
      </>
    );
  }

  return (
    <>
      <SectionLabel right={`${sponsors.length}`}>Sponsors · {year}</SectionLabel>
      <div className="portal-sponsor-grid cols-2">
        {sponsors.map((s, i) => (
          <SponsorCard key={i} name={s.name} logo={s.logo} website={s.website} />
        ))}
      </div>
    </>
  );
}
